module.exports = __webpack_public_path__ + "assets/img/11_803_big.6bf9d508.jpg";